import { loadAndAddImage } from '../image_helpers';

const mapMarkerImageId = `map-marker-distance`;
const mapMarkerImageSrc = `https://cdn-assets.alltrails.com/assets/icons/maps/markers/map-marker-distance@2x.png`;

const addDistanceMarkerImagesToMap = map => {
  const imageId = mapMarkerImageId;
  const imageSrc = mapMarkerImageSrc;
  return loadAndAddImage(map, imageId, imageSrc, {
    stretchX: [[36, 68]],
    pixelRatio: 2
  });
};

const createDistanceMarkerLayer = (id, sourceId) => {
  return {
    id,
    type: 'symbol',
    source: sourceId,
    layout: {
      'icon-allow-overlap': true,
      'icon-ignore-placement': true,
      'icon-image': ['image', mapMarkerImageId],
      'icon-text-fit': 'both',
      'icon-text-fit-padding': [10, 14, 14, 14],
      'text-field': ['get', 'label'],
      'text-font': ['Proxima Nova Regular'],
      'text-size': 11
    }
  };
};

export { addDistanceMarkerImagesToMap, createDistanceMarkerLayer };
